import { SiteHeader } from './SiteHeader';

export function Header() {
  return <SiteHeader tag="/jwtgen" />;
}
